// eslint-disable-next-line
import { LoginLayout } from '@/layouts'

export const asyncRouterMap = [
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    redirect: '/main_home'
  },
  {
    path: '/home',
    redirect: '/main_home'
  },
  {
    path: '/main_home',
    name: 'Home',
    component: () => import('@/views/home/home'),
    meta: { title: '统一门户', icon: 'iconshouye', keepAlive: false }
  },
  {
    path: '/login',
    component: LoginLayout,
    redirect: {
      name: 'CommonLogin'
    },
    hidden: true,
    children: [
      {
        path: 'page',
        name: 'CommonLogin',
        component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue'),
        meta: {
          title: '登录'
        }
      },
      {
        path: 'first',
        name: 'First',
        component: () => import(/* webpackChunkName: "login" */ '@/views/reset_password/reset_password.vue'),
        redirect: {
          name: 'FVerifyPhone'
        },
        children: [
          {
            path: 'step_1',
            name: 'FVerifyPhone',
            component: () => import('@/views/reset_password/modules/verify_phone.vue'),
            meta: {
              title: '验证手机'
            }
          },
          {
            path: 'step_2',
            name: 'FSetPassword',
            component: () => import('@/views/reset_password/modules/set_password.vue'),
            meta: {
              title: '验证手机'
            }
          },
          {
            path: 'step_3',
            name: 'FDone',
            component: () => import('@/views/reset_password/modules/done.vue'),
            meta: {
              title: '验证手机'
            }
          }
        ]
      },
      {
        path: 'change_init_pwd',
        name: 'ChangeInitPwd',
        component: () => import(/* webpackChunkName: "login" */ '@/views/reset_password/reset_password.vue'),
        redirect: {
          name: 'CVerifyPhone'
        },
        children: [
          {
            path: 'step_1',
            name: 'CVerifyPhone',
            component: () => import('@/views/reset_password/modules/verify_phone.vue'),
            meta: {
              title: '修改初始密码'
            }
          },
          {
            path: 'step_2',
            name: 'CSetPassword',
            component: () => import('@/views/reset_password/modules/set_password.vue'),
            meta: {
              title: '修改初始密码'
            }
          },
          {
            path: 'step_3',
            name: 'CDone',
            component: () => import('@/views/reset_password/modules/done.vue'),
            meta: {
              title: '修改初始密码'
            }
          }
        ]
      },
      {
        path: 'forgetpwd',
        name: 'ForgetPwd',
        component: () => import(/* webpackChunkName: "login" */ '@/views/reset_password/reset_password.vue'),
        redirect: {
          name: 'RVerifyPhone'
        },
        children: [
          {
            path: 'step_1',
            name: 'RVerifyPhone',
            component: () => import('@/views/reset_password/modules/verify_phone.vue'),
            meta: {
              title: '忘记密码'
            }
          },
          {
            path: 'step_2',
            name: 'RSetPassword',
            component: () => import('@/views/reset_password/modules/set_password.vue'),
            meta: {
              title: '忘记密码'
            }
          },
          {
            path: 'step_3',
            name: 'RDone',
            component: () => import('@/views/reset_password/modules/done.vue'),
            meta: {
              title: '忘记密码'
            }
          }
        ]
      }
      // {
      //   path: 'superlogin',
      //   name: 'SuperLogin',
      //   component: () => import(/* webpackChunkName: "login" */'@/views/superLogin/superLogin.vue'),
      //   meta: {
      //     title: '超级登录'
      //   }
      // }
    ]
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/views/exception/404')
  }
]

export const allRouters = constantRouterMap.concat(asyncRouterMap)
